import settings from '../settings';
import api from './base';

export async function uploadFile(filename: string, file: Blob, category = 'featured') {
  const uri = `${settings.getApiURI()}/aws/v2/s3/temp-auth`;
  const params = {
    category,
    filename,
    fileType: file.type,
  };

  try {
    const result = await api.http.get(uri, { params });

    const signedUrl = result.data.signedRequest;

    await api.http.put(signedUrl, file, {
      headers: {
        'Cache-Control': 'No-cache',
        'Content-Type': file.type,
      },
    });

    return result;
  } catch (e) {}
}
